"use client";
import React from "react";
import Image from "next/image";
import { Center, HStack } from "@chakra-ui/react";
import { Heading } from "@/elements";
import NvidiaWhite from "public/gpu-hosting/NVIDIA-logo-wbg.png";
import Nvidia from "public/gpu-hosting/NVIDIA-logo-bbg.png";
import ConsumerGpuTable from "@/views/pricing/components/tables/gpuTables/consumerGPU";
import EnterpriseGpuPricingTable from "@/views/pricing/components/tables/gpuTables/enterpriseGPU";
import { PRICING_HEADING_CONSTANTS } from "./constants";

export const tablist = [
  {
    component: <EnterpriseGpuPricingTable showHeading={false} />,
    label: ({ isSelected }) => (
      <Center>
        <HStack gap={2}>
          <Image
            src={isSelected ? Nvidia : NvidiaWhite}
            alt="image"
            width="64"
            height="64"
            style={{
              objectFit: "contain",
            }}
          />
          <Heading fontWeight={600} variant={"subTitle3"}>
            {PRICING_HEADING_CONSTANTS.enterprise}
          </Heading>
        </HStack>
      </Center>
    ),
  },
  {
    component: <ConsumerGpuTable showHeading={false} />,
    label: ({ isSelected }) => (
      <Center>
        <HStack gap={2}>
          <Image
            src={isSelected ? Nvidia : NvidiaWhite}
            alt="image"
            width="64"
            height="64"
            style={{
              objectFit: "contain",
            }}
          />
          <Heading fontWeight={600} variant={"subTitle3"}>
            {PRICING_HEADING_CONSTANTS.consumer}
          </Heading>
        </HStack>
      </Center>
    ),
  },
];
